<template>
  <el-dialog :title="$t('floorShare.addTitle')" :visible.sync="dialogVisible" width="40%" @close="handleClose">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" class="text-left" label-position="right">
      <el-form-item :label="$t('floorShare.floor')" prop="floorNum">
        <el-input v-model="form.floorNum" disabled />
      </el-form-item>

      <el-form-item v-if="form.type === 'unit'" :label="$t('floorShare.unit')" prop="unitNum">
        <el-input v-model="form.unitNum" disabled />
      </el-form-item>

      <el-form-item :label="$t('floorShare.meterType')" prop="meterType">
        <el-select v-model="form.meterType" style="width:100%">
          <el-option v-for="item in meterTypes" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('floorShare.meterNum')">
        <el-input v-model="form.meterNum" :placeholder="$t('floorShare.meterNumPlaceholder')" />
        <span class="tip-text">{{ $t('floorShare.meterNumTip') }}</span>
      </el-form-item>

      <el-form-item :label="$t('floorShare.meterPosition')">
        <el-input v-model="form.meterPosition" :placeholder="$t('floorShare.meterPositionPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('floorShare.feeItem')" prop="configId">
        <el-select v-model="form.configId" style="width:100%">
          <el-option v-for="item in feeConfigs" :key="item.configId" :label="item.feeName" :value="item.configId" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('floorShare.feePrice')" prop="sharePrice">
        <el-input v-model.number="form.sharePrice" type="number" />
      </el-form-item>

      <el-form-item :label="$t('floorShare.meterRatio')">
        <el-input v-model.number="form.meterRatio" type="number" :placeholder="$t('floorShare.meterRatioPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('floorShare.isDeduction')">
        <el-select v-model="form.isDeduction" style="width:100%">
          <el-option v-for="item in isDeductionTypes" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('floorShare.shareType')" prop="shareType">
        <el-select v-model="form.shareType" style="width:100%" @change="handleShareTypeChange">
          <el-option v-for="item in shareTypes" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="form.shareType === '3003'" :label="$t('floorShare.formula')" prop="formulaValue">
        <el-input v-model="form.formulaValue" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveFloorShareMeter, listFeeConfigs } from '@/api/fee/floorShareApi'

export default {
  name: 'AddFloorShare',
  data() {
    return {
      dialogVisible: false,
      form: {
        floorId: '',
        floorNum: '',
        unitId: '',
        unitNum: '',
        type: '', // 'floor' or 'unit'
        meterType: '',
        meterNum: '',
        meterPosition: '',
        shareType: '',
        formulaValue: '',
        configId: '',
        sharePrice: '',
        meterRatio: 1,
        isDeduction: '1',
        communityId: ''
      },
      feeConfigs: [],
      isDeductionTypes: [
        { value: '1', label: this.$t('floorShare.isDeductionAdd') },
        { value: '2', label: this.$t('floorShare.isDeductionDeduct') }
      ],
      meterTypes: [
        { value: 'D', label: this.$t('floorShare.electricMeter') },
        { value: 'S', label: this.$t('floorShare.waterMeter') },
        { value: 'GJS', label: this.$t('floorShare.publicDeductWaterMeter') },
        { value: 'GJD', label: this.$t('floorShare.publicDeductElectricMeter') },
        { value: 'BGDB', label: this.$t('floorShare.officeElectricFee') },
        { value: 'DSDJDB', label: this.$t('floorShare.collectionPaymentMeter') },
        { value: 'GTFTB', label: this.$t('floorShare.allOwnerShareMeter') }
      ],
      shareTypes: [
        { value: '1001', label: this.$t('floorShare.byArea') },
        { value: '2002', label: this.$t('floorShare.byHouse') },
        { value: '3003', label: this.$t('floorShare.byFormula') }
      ],
      rules: {
        meterType: [
          { required: true, message: this.$t('floorShare.meterTypeRequired'), trigger: 'blur' }
        ],
        configId: [
          { required: true, message: this.$t('floorShare.feeItemRequired'), trigger: 'blur' }
        ],
        sharePrice: [
          { required: true, message: this.$t('floorShare.feePriceRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('floorShare.feePriceNumber'), trigger: 'blur' }
        ],
        shareType: [
          { required: true, message: this.$t('floorShare.shareTypeRequired'), trigger: 'blur' }
        ],
        formulaValue: [
          { required: true, message: this.$t('floorShare.formulaRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(data) {
      this.form = {
        floorId: data.floorId || '',
        floorNum: data.floorNum || '',
        unitId: data.unitId || '',
        unitNum: data.unitNum || '',
        type: data.type || 'floor',
        communityId: data.communityId,
        meterType: '',
        meterNum: '',
        meterPosition: '',
        shareType: '',
        formulaValue: '',
        configId: '',
        sharePrice: '',
        meterRatio: 1,
        isDeduction: '1'
      }
      
      if (this.form.type === 'unit' && this.form.unitId) {
        this.getUnitInfo()
      } else if (this.form.type === 'floor' && this.form.floorId) {
        this.getFloorInfo()
      }
      
      this.loadFeeConfigs()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    async loadFeeConfigs() {
      try {
        const params = {
          page: 1,
          row: 500,
          communityId: this.form.communityId,
          feeTypeCd: '888800010017',
          isDefault: 'F',
          state: 'Y'
        }
        const { feeConfigs } = await listFeeConfigs(params)
        this.feeConfigs = feeConfigs
      } catch (error) {
        this.$message.error(this.$t('floorShare.fetchFeeConfigError'))
      }
    },
    async getFloorInfo() {
      try {
        // 这里需要调用API获取楼栋信息
        // 由于当前API可能不支持单独查询楼栋，我们暂时使用传入的数据
        if (!this.form.floorNum) {
          // 如果没有floorNum，可能需要调用API获取
          console.log('Need to fetch floor info for floorId:', this.form.floorId)
        }
      } catch (error) {
        console.error('获取楼栋信息失败:', error)
      }
    },
    async getUnitInfo() {
      try {
        // 这里需要调用API获取单元信息
        // 由于当前API可能不支持单独查询单元，我们暂时使用传入的数据
        if (!this.form.unitNum) {
          // 如果没有unitNum，可能需要调用API获取
          console.log('Need to fetch unit info for unitId:', this.form.unitId)
        }
      } catch (error) {
        console.error('获取单元信息失败:', error)
      }
    },
    handleShareTypeChange(value) {
      if (value !== '3003') {
        this.form.formulaValue = ''
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const submitData = { ...this.form }
            
            // 根据类型设置相应的ID，但都保留floorId用于后端验证
            if (this.form.type === 'unit') {
              submitData.unitId = this.form.unitId
              // 不删除floorId，后端需要它进行验证
            } else {
              submitData.floorId = this.form.floorId
              delete submitData.unitId // 删除unitId，避免冲突
            }
            
            await saveFloorShareMeter(submitData)
            this.$message.success(this.$t('floorShare.addSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            this.$message.error(error.message || this.$t('floorShare.addFailed'))
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.tip-text {
  font-size: 12px;
  color: #909399;
  margin-left: 10px;
}
</style>